import React from 'react';

import { Link } from 'react-router-dom';

export const FabButtonLink = React.forwardRef<HTMLAnchorElement, React.ComponentProps<typeof Link>>(
  (props, ref) => <Link ref={ref} {...props} />
);
